import { Injectable } from '@angular/core';

import { AppMode, InputMode } from 'app/features/settings/models';
import { AppSettings } from 'app/features/settings/models/app-settings';
import { StorageService } from 'app/shared/services';

const allowManualSelectionKey = 'allow-manual-selection';
const appModeKey = 'app-mode';
const inputModesKey = 'input-modes';
const masterDataCacheDurationInMsKey = 'settings-cache-duration';
const scanFlowRegistrationSubmitIntervalMsKey = 'scan-flow-reg-submit-interval';

@Injectable({ providedIn: 'root' })
export class SettingsStorageService {
    constructor(private storage: StorageService) {}

    getAppSettingsFromStorage(): Partial<AppSettings> {
        return {
            allowManualSelection: this.storage.get<boolean>(allowManualSelectionKey),
            appMode: this.storage.get<AppMode>(appModeKey),
            inputModes: this.storage.get<InputMode[]>(inputModesKey),
            masterDataCacheDurationInMs: this.storage.get<number>(masterDataCacheDurationInMsKey),
            scanFlowRegistrationSubmitIntervalMs: this.storage.get<number>(
                scanFlowRegistrationSubmitIntervalMsKey,
            ),
            userSessionExpirationTime: undefined,
        };
    }

    putAppSettingsToStorage({
        allowManualSelection,
        appMode,
        inputModes,
        masterDataCacheDurationInMs,
        scanFlowRegistrationSubmitIntervalMs,
    }: AppSettings): void {
        // Store allowManualSelection only if appMode is personal as multiuser will always be true
        if (appMode === 'personal') {
            this.storage.store(allowManualSelectionKey, allowManualSelection);
        }
        this.storage.store(appModeKey, appMode);
        this.storage.store(inputModesKey, inputModes);
        this.storage.store(masterDataCacheDurationInMsKey, masterDataCacheDurationInMs);
        this.storage.store(scanFlowRegistrationSubmitIntervalMsKey, scanFlowRegistrationSubmitIntervalMs);
    }
}
